"use client";

import { useAuth } from "@/contexts/AuthContext";
import { forumError, toast } from "@/lib/forum.client";

export function useForumAuth() {
    const { isAuthenticated, openAuthModal, user } = useAuth();

    const name =
        user?.username ||
        (user && typeof user.info === "object" ? user.info?.name : undefined) ||
        user?.firstName ||
        "کاربر";
    const initial = String(name).trim().charAt(0) || "ک";

    /** اگر کاربر وارد نشده باشد، پنجره‌ی ورود را باز می‌کند و false برمی‌گرداند */
    const guard = (): boolean => {
        if (!isAuthenticated) {
            toast("برای این کار ابتدا وارد حساب کاربری شوید.");
            openAuthModal("login");
            return false;
        }
        return true;
    };

    const handleError = (e: unknown) => {
        const err = forumError(e);
        if (err.status === 401) {
            toast("نشست شما منقضی شده است. دوباره وارد شوید.");
            openAuthModal("login");
        } else {
            toast(err.message);
        }
    };

    return { isAuthenticated, initial, guard, handleError };
}
